import { action } from 'satcheljs';
import { TxpEventFlagsV2 } from '../utils/getTxpFlagInfo';

/**
 * The type encapsulating all the flags that can be set on the TxpOptionState
 */
type TxpStateFlagsV2 = 'CreateEventsFromEmailAsPrivate';

export let updateTxpFlagV2 = action(
    'updateTxpFlagV2',
    (flagName: TxpStateFlagsV2 | TxpEventFlagsV2, enabled?: boolean, value?: number) => ({
        flagName: flagName,
        enabled: enabled,
        value: value,
    })
);
